// extracted by mini-css-extract-plugin
export var heroImage = "_dw-1";
export var modal = "_dw-0";